/**
 * RPC Schema: Get Vanguard Preview Customers
 *
 * Returns up to 25 customers for AI content preview generation across 5 marketing scenarios.
 * Fetches 25 customers per event type, then round-robins through event types to select
 * one of each type repeatedly until reaching 25 total customers.
 * This ensures maximum diversity - each "page" of 5 has one customer per event type.
 *
 * Scenarios:
 * - EMAIL_SIGNUP: MARKETING_SUBSCRIBED event
 * - BROWSE_ABANDONED: STORE_PAGE_VIEWED event
 * - CART_ABANDONED: PRODUCT_ADDED_TO_CART event
 * - PRICE_DROP: PRODUCT_VIEWED event
 * - BACK_IN_STOCK: TRIGGERED_BACK_IN_STOCK_NOTIFICATION event
 */

import { MarketingTriggerKey } from "@redotech/redo-model/advanced-flow/triggers";
import * as z from "zod/v4";

const PreviewCustomerSchema_ = z.object({
  customerId: z.string(),
  name: z.string().nullable(),
  location: z.string().nullable(),
  eventTimestamp: z.date(),
  eventType: z.nativeEnum(MarketingTriggerKey).nullable(),
});

export const PreviewCustomerSchema: z.ZodType<PreviewCustomerSchema> =
  PreviewCustomerSchema_;
export interface PreviewCustomerSchema
  extends z.infer<typeof PreviewCustomerSchema_> {}

export const getVanguardPreviewCustomers = {
  name: "getVanguardPreviewCustomers" as const,
  input: z.object({ limit: z.number().min(1).optional() }),
  output: z.object({ customers: z.array(PreviewCustomerSchema) }),
};
